<template>
    <div class="sales-items-mainpage" v-if="projectItems != null">
        <div class="container"> 
            <salesFilter class="sales-filter-main-page-items"></salesFilter>
            <salesItems v-if="!isMobileChecker"></salesItems>
            <salesItemsMobile v-else></salesItemsMobile>
            <div class="btn-route-to-all">
                <router-link to="/sales">
                    <span v-if="globalLang == ''">ПОСМОТРЕТЬ ВСЕ ЖК</span>
                    <span v-if="globalLang == 'kz/'">Барлық ТК қараңыз</span>
                    <span v-if="globalLang == 'en/'">View all residential complexes</span>
                </router-link>
            </div>
            <!-- <a href="#" class="btn-load-all">Загрузить еще</a> -->
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import salesItems from '@/components/sales/sale-item-new.vue'
    import salesItemsMobile from '@/components/sales/sale-item-mobile.vue'
    // import salesItems from '@/components/sales/sale-item.vue'
    import salesFilter from '@/components/sales-filter/sales-filter.vue'
    export default {
        name: 'sales-items-main-page',
        components: {
            salesItems,
            salesItemsMobile,
            salesFilter,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                routerName: this.$router.history.current.name,
            }
        },
        computed: mapGetters({
            projectItems: 'loadProjectItems',
            projectItemsDefault: 'loadProjectItemsDefault',
            projectItemsFilter: 'loadProjectItemsFilter',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
            // this.$store.dispatch('getSalesPageData');
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-items-promo.scss';
    @import '@/styles/respond/sales/respond-promo-sales-items.scss';
</style>